import { ErrorHandler, Injectable, inject } from '@angular/core';
import { LoggerService } from './logger.service';
import { getSanitizedUrl, isHttpError } from './logger-helper';

/**
 * Global error handler for capturing Angular framework errors.
 * Logs all errors through the LoggerService to Sumo Logic.
 * Works in conjunction with browser-level error handlers set up in ErrorBootstrapService
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly logger = inject(LoggerService);

  handleError(error: any): void {
    // Skip HTTP errors - they're already logged by the logging-interceptor
    if (isHttpError(error)) {
      return;
    }

    this.logger.log({
      type: 'error',
      context: 'Angular Framework Error',
      message: error instanceof Error ? error.message : String(error),
      stack: error instanceof Error ? error.stack : undefined,
      userAgent: globalThis.navigator.userAgent,
      url: getSanitizedUrl(),
    });

    // Still log to console for development/debugging
    console.error('[Angular Error Handler]', error);
  }
}
